import React, { useState } from 'react';
import { useStore } from '../../../store';
import { useGenerateLinkToken } from '../../../hooks/query/useGenerateLinkToken';
import { IPostLinkData } from '../../../types';
import { trackMixPanel } from '../../../services/mixpanel.service';
import { PlaidLink } from './PlaidLink';
import Spinner, { SpinnerColor } from '../../../generic-components/Spinner';

interface IMixpanelEvent {
  eventName: string,
  action: string
}

interface IPlaidActionButton {
  title: string,
  preIcon?: React.ReactNode,
  className: string,
  testId: string,
  callbackHandler: (data: IPostLinkData) => void,
  mixpanelEvent?: IMixpanelEvent,
  isLoading: boolean,
}

const PlaidActionButton = (
  {
    title,
    preIcon,
    className,
    testId,
    callbackHandler,
    mixpanelEvent,
    isLoading,
  }: IPlaidActionButton,
) => {
  const { customerId } = useStore(state => state.user);
  const [linkToken, setLinkToken] = useState<string>('');
  const { refetch: fetchLinkToken, isLoading: isFetchLinkToken } = useGenerateLinkToken(customerId);
  const handlePostLink = (data: IPostLinkData) => {
    setLinkToken('');
    callbackHandler(data);
  };
  const handleGenerateToken = () => {
    if (mixpanelEvent?.eventName && mixpanelEvent?.action) trackMixPanel(mixpanelEvent.eventName, { Action: mixpanelEvent.action });
    fetchLinkToken()
      .then(({ data }) => {
        const { linkToken: { link_token: linkTokenRes } } = data;
        setLinkToken(linkTokenRes);
      });
  };
  const isInLoadingMode = isLoading || isFetchLinkToken;
  return (
    <>
      {
        !linkToken
        && (
          <button
            type='button'
            data-testid={testId || 'plaidWrapperCTA'}
            disabled={isInLoadingMode}
            onClick={() => handleGenerateToken()}
            className={className}
          >
            {!isInLoadingMode && preIcon && <div>{preIcon}</div>}
            {!isInLoadingMode ? title : <Spinner spinnerColor={SpinnerColor.White} height='2rem' width='2rem' />}
          </button>
        )
      }
      {
        linkToken
        && (
          <PlaidLink
            shouldAutoOpenLink
            isLoading={isInLoadingMode}
            linkToken={linkToken}
            title={title}
            className={className}
            handlePostLink={handlePostLink}
            preIcon={preIcon}
          />
        )
      }
    </>
  );
};

export default PlaidActionButton;
